import { render, staticRenderFns } from "./TotalizadorDocumentos.vue?vue&type=template&id=069840b5&"
import script from "./TotalizadorDocumentos.vue?vue&type=script&lang=js&"
export * from "./TotalizadorDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./TotalizadorDocumentos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports